import { Badge } from "@/design-system/components/react";
import { Hint } from "@/components/devicePanel/Hint";

/** A notification-view page's research label, when its panel has one: shown once,
 * in full, across the top. */
export function ResearchBanner({ label }: { label: string | null }) {
  if (label === null) return null;
  return (
    <p
      role="note"
      className="border-b border-border-strong bg-surface-2 px-4 py-1.5 text-[11px] font-medium text-fg-muted"
    >
      {label}
    </p>
  );
}

/** Always-visible research marker (a regulatory guardrail): compact, with the
 * panel's full `research_label` in its tooltip. A research panel without one is
 * an error, never an unmarked view. */
export function ResearchTag({ label }: { label: string | null }) {
  if (label === null) throw new Error("A research panel has no research_label");
  return (
    <Hint label={label}>
      <Badge
        tabIndex={0}
        aria-label={`Research: ${label}`}
        variant="outline"
        className="shrink-0 cursor-default rounded-xs border-border-strong px-1.5 py-0 text-[10px] font-medium uppercase tracking-[0.08em] text-fg-muted focus:ring-0 focus-visible:outline focus-visible:outline-1 focus-visible:outline-signal"
      >
        Research
      </Badge>
    </Hint>
  );
}
